<template>
  <b-container fluid class="servico">
    <b-row align-v="center" class="text-center">
    <!-- <header class="section-header">
      <h3>Serviços</h3>
      <p></p>
    </header> -->
    <!--<b-row>
      <b-col col lg="4" md="6" sm="12" cols="12">
        <div class="serviceBox purple" @click.prevent="mostrartexto(1)">
          <div class="service-icon">
            <img src="../img/avatar/avatar_1.jpeg" alt="Avatar" class="avatar">
          </div>
          <h4 class="title">
            <a>“Aulas especiais”? Elas existem?</a>
          </h4>
          <p class="description"> clique para saber mais... </p>
        </div>
      </b-col>
      <b-col col lg="4" md="6" sm="12" cols="12">
        <div class="serviceBox purple" @click.prevent="mostrartexto(2)">
          <div class="service-icon">
            <img src="../img/avatar/avatar_2.jpeg" alt="Avatar" class="avatar">
          </div>
          <h4 class="title">
            <a href>Como é nossa Rotina?</a>
          </h4>
          <p class="description"> clique para saber mais... </p>
        </div>
      </b-col>
      <b-col col lg="4" md="6" sm="12" cols="12">
        <div class="serviceBox purple" @click.prevent="mostrartexto(3)">
          <div class="service-icon">
            <img src="../img/avatar/avatar_3.jpeg" alt="Avatar" class="avatar">
          </div>
          <h4 class="title">
            <a href>"Prof" posso assistir a aula?</a>
          </h4>
          <p class="description"> clique para saber mais... </p>
        </div>
      </b-col>

      <b-modal
        size="lg"
        scrollable
        centered
        hide-footer
        v-model="modalCad"
        id="modal-2"
        title=""
        :class="'modal-box'"
      >


        <template v-slot:modal-header="{ close }">
          <div class="iconmodal">
            <img v-if="inTexto1" src="../img/avatar/avatar_1.jpeg" alt="Avatar" class="avatar"></i>
            <img v-if="inTexto2" src="../img/avatar/avatar_2.jpeg" alt="Avatar" class="avatar"></i>
            <img v-if="inTexto3" src="../img/avatar/avatar_3.jpeg" alt="Avatar" class="avatar"></i>
          </div>
          <div class="btfechar">
            <button type="button" class="close"  data-dismiss="modal" aria-label="Close" @click="close()"><span aria-hidden="true">×</span></button>
          </div>
        </template>

         <template v-slot:default="{ hide }">

            <div v-if="inTexto1">
              
              <h3 class="title">“Aulas especiais”? Elas existem?</h3>
              <p class="description">
                Todos os meses nós realizamos algumas aulas diferenciadas, cada uma com um objetivo específico:
              </p>
              <p class="description">
                Temos nossa aula de teoria, onde a relembramos conteúdos já apresentados às pequenas. Buscamos correlacionar o que vivenciamos na prática com ilustrações, desenhos que as vezes são elaborados pelas próprias bailarinas e atividades diversas que abarcam atividades de psicomotricidade fina.
              </p>
              <p class="description">
                As aulas de alongamento não podem faltar. É um momento em que passamos toda a aula com foco em explorar melhor os limites e possibilidades de cada corpo, e conhece-lo de forma mais específica.
              </p>
              <p class="description">
                E não podemos esquecer das aulas de recreação, que aparecem uma vez por mês, para alegria das nossas pequenas, que amam se divertir, ter um momento de descontração com as amigas, e aprender sempre algo novo.
              </p>          

          </div>     

          <div v-if="inTexto2">

              <h3 class="title">Como é nossa Rotina? </h3>

              <p class="description">
                Nossas aulas acontecem duas vezes por semana, e tem duração de 45 minutos. Iniciamos ela com um aquecimento, depois de termos os corpos aquecidos vamos a técnica do balé clássico. 
              </p>
              <p class="description">
                Na sequência fazemos algum exercício que tenha foco em desenvolver alguma habilidade específica, e por fim, encerramos a aula com alguma brincadeira, que tem sempre algum objetivo inserido por meio da ludicidade.
              </p>
              <p class="description">
                Em todas as etapas da aula, as brincadeiras, o lúdico e a fantasia estão inseridas. A criança sempre é colaboradora nesse processo, tendo espaço para ser ouvida e vivenciar todas as etapas das aulas.
              </p>

          </div>

          <div v-if="inTexto3">

              <h3 class="title">"Prof. posso assistir a aula?"</h3>

              <p class="description">
                O início das crianças no Balé é sempre um momento de muito entusiasmo, para pequenas, mas também para os pais, e é comum ouvir alguma mamãe perguntando: "Prof°, posso assistir a aula?"  
              </p>
              <p class="description">
                Nós sabemos o quanto é difícil ficar do lado de fora da sala enquanto sua pequena bailarina faz as primeiras aulas de Balé, mas esse contato com a professora, sem a presença dos pais, é de extrema importância para criar uma conexão entre ambas, e assim gerar confiança e afinidade! 
              </p>
              <p class="description">
                Sabe o que é mais legal? Para encerrar o primeiro semestre convidamos os familiares de nossas bailarinas para assistirem a uma aula! É a nossa "Aula Expositiva"!  
              </p>
              <p class="description">
                E no encerramento do segundo semestre realizamos o nosso Espetáculo Anual, oportunidade de levar parentes e amigos para assistirem sua bailarina brilhar e encantar!
              </p>
              <p class="description">
                Então não precisa se preocupar, você pode assistir a aula sim, no momento certo, ok?!
              </p>
          </div> 

        </template>
        

      </b-modal>
     
    </b-row>-->
      <b-col cols="12">
        <h2>Por que nós?</h2>
      </b-col>
      <b-col cols="12">
        <h5>Porque aqui o balé é muito mais divertido.</h5>
      </b-col>
    </b-row>
    <b-row align-self="center">
      <why-us ref="whyus"></why-us>
    </b-row>
  </b-container>
</template>

<script>
import WhyUs from "./porquenos.vue";
import mensagem from "./mensagem.vue";

export default {
  name: "servico_cp",
  components: {
    WhyUs,
    mensagem
  },
  data() {
    return {
      modalCad: false,
      msgcontext: '',
      inTexto1: false,
      inTexto2: false,
      inTexto3: false,
      texto1: '',
      texto2: '',
      texto3: '',
    };
  },
  created() {
  },
  methods: {
    mostrartexto (item) {
      this.inTexto1 = false
      this.inTexto2 = false
      this.inTexto3 = false
      if (item == 1) {
        this.inTexto1 = true
      } else if (item == 2) {
        this.inTexto2 = true
      }else if (item == 3) {
        this.inTexto3 = true
      }
      this.modalCad = !this.modalCad
    },
    animationElement(posEl, isMostrar) {
      if (this.$refs.whyus) this.$refs.whyus.animationElement(posEl, isMostrar)
    },
  }
};
</script>

<style>

.servico {
  padding: 100px 0 100px 0;
  min-height: 100vh;
}

#services {
  padding: 100px 0 100px 0;
  min-height: 100vh;
}


.serviceBox{
    background: #fff;
    font-family: 'Raleway', sans-serif;
    text-align: center;
    padding: 0px 15px 25px;
    margin: 10px;
    border: 2px solid #ff4757;
    border-radius: 50px 0;
    box-shadow: 0 0 120px rgba(0,0,0,0.5) inset;
    position: relative;
    transition: all 0.3s ease 0s;
    min-height: 350px;
}
.serviceBox:before,
.serviceBox:after{
    content: "";
    width: 25px;
    height: 25px;
    border-top: 7px solid #ff6b81;
    border-right: 7px solid #ff4757;
    position: absolute;
    top: -7px;
    right: -7px;
}
.serviceBox:after{
    border-top: none;
    border-right: none;
    border-bottom: 7px solid #ff4757;
    border-left: 7px solid #ff6b81;
    top: auto;
    right: auto;
    bottom: -7px;
    left: -7px;
}

.serviceBox:hover{
  -webkit-transform: scale(1.07);
  transform: scale(1.07);
}

.serviceBox .service-icon{
    color: #fff;
    background: #ff6b81;
    font-size: 35px;
    width: 180px;
    padding: 0 0 5px;
    margin: 0 auto 30px;
    border-radius: 0 0 15px 15px;
    box-shadow: 3px 3px 3px rgba(0,0,0,0.2);
    position: relative;
}
.serviceBox:hover .service-icon i {
    transform: rotateX(190deg);
    transition: all 0.5s;
}
.serviceBox .service-icon:before{
    content: "";
    background: #ff6b81;
    width: calc(100% + 14px);
    height: 10px;
    transform: translateX(-50%);
    position: absolute;
    top: -10px;
    left: 50%;
}
.serviceBox .service-icon span:before,
.serviceBox .service-icon span:after{
    content: '';
    background-color: #ff4757;
    height: 10px;
    width: 15px;
    border-radius: 10px 10px 0 0;
    position: absolute;
    left: -15px;
    top: -10px;
}
.serviceBox .service-icon span:after{
    left: auto;
    right: -15px;
}
.serviceBox .title{
    color: #322663 !important;
    font-size: 25px;
    font-weight: 600;
    text-transform: uppercase;
    margin: 50px 0 10px;
}

.serviceBox .description{
    font-size: 15px;
    /*line-height: 25px;*/
    margin-bottom: 50px;
}

.serviceBox.purple{ border-color: #974548 ; }
.serviceBox.purple:before{
    border-top-color: #974548 ;
    border-right-color: #974548 ;
}
.serviceBox.purple:after{
    border-left-color: #974548 ;
    border-bottom-color: #974548 ;
}
.serviceBox.purple .service-icon,
.serviceBox.purple .service-icon:before{
    background-color: #974548 ;
}
.serviceBox.purple .service-icon span:before,
.serviceBox.purple .service-icon span:after{
    background-color: #974548 ;
}
.serviceBox.purple .title{ color: #974548 !important; }
.serviceBox.purple .title a{ color: #974548 !important; }
.serviceBox.purple .description{ 
  color: #974548 !important;
  font-size: 15px;
  font-weight: bold;
  line-height: 40px; 
}

.serviceBox.purple:hover .service-icon i {
    transform: rotateX(190deg) !important;
    transition: all 0.5s !important;
}

.serviceBox.purple .profile{
    width: 60px;
    height: 60px;
    vertical-align: middle;
    border-radius: 50%;
    overflow: hidden;
}

.serviceBox.purple .avatar {
  width: 160px;
  height: 16  0px;
  border-radius: 50%;
}



#modal-2 .modal-content {
  color: #fff;
	background-color: #974548;
	font-size: 18px;
	font-weight: 600;
	padding: 10px 15px;
	margin: 80px auto 0;
	border: none;
	box-shadow: 10px 10px 8px rgba(0, 0, 0, 0.2);
	outline: none;
}

#modal-2 .modal-content{
	color: #974548;
	background-color: #fff;
	border: none;
	box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.1) inset;
}


#modal-2 .show-modal:hover{
	color: #974548;
	background-color: #fff;
	border: none;
	box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.1) inset;
}

body.modal-open {
  /*height: 100vh !important;*/
  overflow-y: hidden !important;
}

#modal-2 .modal-backdrop.in{ opacity: 0; }
#modal-2 .modal{ top: 90px !important; }
#modal-2 .modal-dialog{
	margin: 20px auto 0;
}

#modal-2 .modal-dialog .modal-content{
	text-align: center;
	border: none;
	position: relative;
}
#modal-2 .modal-dialog .modal-content:before{
	content: "";
	background: #974548;
	width: 100%;
	height: 100px;
	border-radius: 6px 6px 0 0;
	position: absolute;
	top: 0;
	left: 0;
}

.modal-header {
    padding: 12px;
    position: relative;
    padding: 12px;
    height: 90px;
    border: 0;
}


#modal-2 .modal-content .modal-header .iconmodal {
	color: #974548;
	background: #fff;
	font-size: 65px;
	line-height: 120px;
	width: 120px;
	height: 120px;
  margin: 0 auto;
  left: 50%;
	border-radius: 100px;
  transform: translateY(-30px);
}

#modal-2 .modal-content .modal-header .iconmodal .avatar {
  width: 160px;
  height: 16  0px;
  border-radius: 50%;
}

#modal-2 .modal-content .modal-header:hover .icon  {
  transform: rotateX(190deg);
  transition: all 0.5s;
}

#modal-2 .modal-dialog .modal-header .btfechar{
	content: "";
  position: absolute;
  text-align: right;
  width: 100%;
	top: 0;
	left: 0;
}


#modal-2 .modal-dialog .modal-content .modal-body {
	color: #974548;
	font-size: 18px;
	margin: 50px 0 15px;
}

#modal-2 .modal-dialog .modal-header .close:hover{ color: #fff; }
#modal-2 .modal-content .modal-body{ 
  padding: 15px 25px 30px !important;
}

#modal-2 .modal-dialog .modal-content .modal-body .title{
	color: #974548;
	font-size: 25px;
	font-weight: 800;
	letter-spacing: 1px;
	text-transform: uppercase;
	margin: 0 0 60px;
}

#modal-2 .modal-dialog .modal-content .modal-body .description{
  text-align: justify !important;
	color: #974548;
	font-size: 18px;
	margin: 0 0 15px;
}



@media screen and (max-width: 1700px) {
  .serviceBox .title{
      margin-top: 80px;
  }
}

@media only screen and (max-width:990px){
    .serviceBox{ margin: 10px 10px 50px; }
    .serviceBox .title{
      margin-top: 60px;
    }
}

@media screen and (max-width: 767px) {
  .serviceBox .title{
      margin-top: 60px;
  }
  #modal-2 .modal-dialog{ width: 93% !important; }
  #modal-2 .modal-dialog .modal-content .modal-body .title{
    margin: 0 0 20px;
    font-size: 18px;
  }
  #modal-2 .modal-dialog .modal-content .modal-body .description{
    font-size: 14px;
    margin: 0 0 1px;
  }
  #modal-2 .modal-content .modal-header .iconmodal {
    line-height: 90px !important;
    width: 120px !important;
    height: 120px !important;
  }
  #modal-2 .modal-content .modal-header .iconmodal .avatar {
    width: 130px !important;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/servico.vue